/**
 * Map Global Search section icon ids to MUI icons for Spotlight UI.
 * When adding a new `iconId`, extend `GlobalSearchSectionIconId` and add a case here.
 */

import React from 'react';
import {
  Assignment as AssignmentIcon,
  CalendarMonth as CalendarIcon,
  People as PeopleIcon,
  PersonSearch as LeadIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import type { GlobalSearchSectionIconId } from './types';

export const globalSearchSectionIcon = (
  iconId: GlobalSearchSectionIconId | string,
): React.ReactElement => {
  switch (iconId) {
    case 'patients':
      return <PeopleIcon fontSize="small" />;
    case 'leads':
      return <LeadIcon fontSize="small" />;
    case 'appointments':
      return <CalendarIcon fontSize="small" />;
    case 'tasks':
      return <AssignmentIcon fontSize="small" />;
    default:
      return <SearchIcon fontSize="small" />;
  }
};
